export default __webpack_public_path__ + "static/media/care-icon.02aba3c7.svg";